import React, { useEffect, useState } from 'react'
import Modal from 'react-modal'
import '../../styles/TermsAndConditions.css'
import { useTranslation } from 'react-i18next'
import i18n from '../../i18n'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { ENGLISH_TERMS_AND_CONDITIONS, GERMAN_TERMS_AND_CONDITIONS } from '../../assets/legal/termsAndConditionsConstants.js'
import { ReactComponent as ExitCross } from '../../assets/svg/ExitCross.svg'

function TermsAndConditionsContentModal({ modalIsOpen, closeModal, showBlur = true }) {
    const { t, locale } = useTranslation()
    const [agree, setAgree] = useState(false)

    useEffect(() => {
        if (!showBlur) return
        if (modalIsOpen) {
            Modal.setAppElement('#root')
            document.getElementById('home').style.filter = 'blur(5px)'
        } else {
            document.getElementById('home').style.filter = 'unset'
        }
    }, [modalIsOpen, showBlur])

    const _closeModal = () => {
        closeModal()
    }

    return (
        <Modal
            isOpen={modalIsOpen}
            contentLabel="Tutorial Modal"
            onRequestClose={_closeModal}
            style={{
                overlay: {
                    zIndex: 1111,
                },
                content: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'transparent',
                    padding: 0,
                    border: 'none',
                    boxShadow: 'none',
                    overflow: 'hidden',
                    position: 'absolute',
                },
            }}
        >
            <div className="terms-and-conditions-modal" style={{ zIndex: 1111, width: '80%', height: '90vh', position: 'relative' }}>
                <button className="tutorial-exit-button" onClick={_closeModal} style={{ zIndex: 2 }}>
                    <ExitCross />
                </button>
                <div className="tutorial-right-side">
                    <p className="tutorial-modal-title">{t('Terms and Conditions')} </p>
                    <div style={{ flex: 1, overflow: 'auto' }} className="terms-and-conditions-text">
                        <ReactMarkdown className="markdown" remarkPlugins={[remarkGfm]}>
                            {i18n.language === 'de' ? GERMAN_TERMS_AND_CONDITIONS : ENGLISH_TERMS_AND_CONDITIONS}
                        </ReactMarkdown>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default TermsAndConditionsContentModal
